function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

export { velocityPerSecond };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/node_modules/popmotion/dist/es/utils/velocity-per-second.js
// module id = 88
// module chunks = 0